const APP_USER = {
  userID: '1',
  first_name: 'Test',
  last_name: 'User'
};

export default APP_USER;
